import React, { useContext, useEffect } from "react"

import { NotificationManager } from "react-notifications"
import { useHistory } from "react-router-dom"

import TutorContext from "~Tutor/TutorContext"
import { path } from "~Tutor/TutorRoutes"

import ExpenseForm from "../components/ExpenseForm"

const NewExpense = () => {
  const { viewer } = useContext(TutorContext)
  const history = useHistory()
  const formState = {
    expenseType: "",
    amount: "",
    description: "",
    comments: "",
    receipts: [],
  }

  useEffect(() => {
    if (!viewer.mayCreateExpense) {
      history.push(path("dashboard"))
      NotificationManager.error("You may not create new expenses")
    }
    if (!viewer.billDotComVendorId) {
      history.push(path("dashboard"))
      NotificationManager.error(
        "You have not accepted your Air Tutors bill.com invitation. If you believe you have, please contact an admin."
      )
    }
  }, [history, viewer])

  return <ExpenseForm formState={formState} tutor={viewer} />
}

export default NewExpense
